module.exports = __webpack_public_path__ + "static/media/loop2.135b6fb9.png";